import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {LoginService} from '../../services/login.service';
import {environment} from '../../../environments/environment';
import * as $ from 'jquery';
import {ApiService} from '../../services/api.service';
import {GenericModalComponent} from '../../generic-modal/generic-modal.component';
import {ConfirmDialogTermsComponent} from '../confirmterms/confirmterms-dialog.component';
import {VerifyYourEmailModalComponent} from '../../custom-modals/verify-your-email-modal.component';
import {UnsubscribedUserModalComponent} from '../../custom-modals/unsubscribed-user-modal.component';
import {LoginNoticeModalComponent} from '../../custom-modals/login-notice-modal.component';
import {SignupNoticeModalComponent} from '../../custom-modals/signup-notice-modal.component';
import {ModalService} from '../../services/modalService/modal.service';
import {UtilsService} from '../../services/utils.service';
import {GoogleAnalyticsService} from '../../services/google-analytics-service';
import {TranslateService} from '@ngx-translate/core';

export interface Model {
    title: string;
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent extends DialogComponent<Model, string> implements OnInit {
    title: string;
    action: string;
    loginForm: FormGroup;
    login: any = {};
    error: any;

    constructor(dialogService: DialogService,
                private apiService: ApiService,
                private loginService: LoginService,
                private modalService: ModalService,
                private fb: FormBuilder,
                private ga: GoogleAnalyticsService,
                private utils: UtilsService,
                private translate: TranslateService) {
        super(dialogService);
    }

    ngOnInit() {
        this.action = environment.baseURL + '/signin/provider/google';
        // console.log('Login action: ' + this.action);
        this.loginForm = this.fb.group({
            'email': ['', Validators.compose([Validators.required, Validators.email])],
            'password': ['', Validators.compose([Validators.required])],
            'remember_me': ['']
        });
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    confirm() {
        this.close();
    }

    public submit() {
        $(document).ready(function () {
            $('#googlesign').submit();
        });
    }

	public loginUserRequest(login : any) {
		login.userInfoIp = '';
    	login.userInfoCity = '';
		login.userInfoRegion = '';
		login.userInfoCountry = '';
		login.sendEmail = true;
    	this.loginService.getUserInfo().subscribe((res) => {
			login.userInfoIp = res.json().ip ? res.json().ip : '';
			login.userInfoCity = res.json().city ? res.json().city : '';
			login.userInfoRegion = res.json().region ? res.json().region : '';
			login.userInfoCountry = res.json().country ? res.json().country : '';
			this.loginService.checkLoggedIn(login).subscribe((loggedInUser) => {
           		//console.log('Login success' + loggedInUser.email);
				if(!loggedInUser.paid) {
					this.close();
					this.openMigrationNoticeModal();
				} else {
					this.result = "REPORTS PAGE";
					this.close();
				}
            }, (error) => {
            	if(error.status == 0) {
            		window.location.href='/#/error-page';
            		this.close();
              	} else {
              		this.close();
					this.openMigrationNoticeModal();
                	//this.openValidationErrorModals(error, login);
              	}
            });
        }, (error) => {
        	// console.log(error);
        	this.loginService.checkLoggedIn(login).subscribe((loggedInUser) => {
           		//console.log('Login success' + loggedInUser.email);
				if(!loggedInUser.paid) {
					this.close();
					this.openMigrationNoticeModal();
				} else {
					this.result = "REPORTS PAGE";
					this.close();
				}
            }, (error) => {
            	if(error.status == 0) {
            		window.location.href='/#/error-page';
            		this.close();
              	} else {
              		this.close();
					this.openMigrationNoticeModal();
                	//this.openValidationErrorModals(error, login);
              	}
            });
        });
	}
	
	public openMigrationNoticeModal() {
		// TASK3: after a real backend sign in, show the Log-in transition modal.
		// The cloud login URL uses the email entered on the sign-in form.
		this.modalService.open(LoginNoticeModalComponent, {
			title: this.translate.instant('transition.login.title'),
			data: { email: this.login && this.login.email ? this.login.email : '' }
		}).subscribe((model) => {
			if (model === 'OPEN_SIGNUP') {
				this.openSignupNoticeModal();
			}
		});
	}

	public openSignupNoticeModal() {
		this.modalService.open(SignupNoticeModalComponent, {
			title: this.translate.instant('transition.signup.title'),
			data: {}
		}).subscribe((model) => {
			// "Already have an account?" -> reopen the sign-in form.
			if (model === 'OPEN_LOGIN') {
				this.modalService.open(LoginComponent, { title: 'SIGN IN', data: {} });
			}
		});
	}

	public openValidationErrorModals(error : any, login: any) {
		if(error.status == 406) {
			this.modalService.open(VerifyYourEmailModalComponent, {
	                	title: this.translate.instant('account.verifyYourEmail.title'),
	                	subtitle: this.translate.instant('account.verifyYourEmail.subtitle'),
	                	data: { message1: this.translate.instant('account.verifyYourEmail.message1'),
	                      message2: this.translate.instant('account.verifyYourEmail.message2'),
	        			  messageResend: this.translate.instant('account.verifyYourEmail.messageResend'),
						  messageResendSuccessfully: this.translate.instant('account.verifyYourEmail.messageResendSuccessfully'),
						  messageResendFailed: this.translate.instant('account.verifyYourEmail.messageResendFailed')
	                	}
	            	});
	     }
	}
	
    public loginUser(login) {
        this.ga.emitEvent('Sign In Form', 'Sign In', 'Click');
        if (!this.loginForm.valid) {
            this.utils.validateAllFormFields(this.loginForm);
            return;
        }
        this.loginService.userLogin(login)
            .subscribe((res) => {
            	window.location.href='/#/home';
            	this.loginUserRequest(login);
            }, (error) => {
            	if(error.status == 0) {
            		window.location.href='/#/error-page';
            		this.close();
            	} else {
	                this.error = this.apiService.getMessageFromError(error, this.translate.instant('account.login.errorMessage'));
	                let errorKey = '';
	                if (error && error._body) {
				          try {
				              errorKey = JSON.parse(error._body).message;
				          } catch (exc) {
				              console.log(exc);
				          }
				    }
	                
	                var termsAndConditionsError = 'securityUserError2';
	                var agreeToEmailsError = 'securityUserError5';
	                if(errorKey && errorKey == termsAndConditionsError) {
	                	this.modalService.open(ConfirmDialogTermsComponent, {
	                    	title: this.translate.instant('account.login.updateTerms'),
	                    	data: { message: this.translate.instant('account.login.pleaseAgree'),
	                    		showCancelButton: false,
	                        	unsubModal: true,
	                        	centered: true
	                    	}
	                    }).subscribe((result) => {
	                        if(result){
	                        	this.loginService.agreeTermsOfUserByEmail(login).subscribe((res) => {
	                        		// console.log('Agree Terms Of User By Email success: ' + login.email);
	                        		this.loginService.userLogin(login)
		                                .subscribe((res) => {
		                                    this.loginUserRequest(login);
		                                }, (error) => {
		                                    this.error = this.apiService.getMessageFromError(error,
	                                            this.translate.instant('account.login.failAgree'));
		                                })
	                        	}, (error) => {
	                        		throw error;
	                        	})
	                        }
	                    });
	                    this.close();
	                } else if(errorKey && errorKey == agreeToEmailsError) {
	                	this.modalService.open(UnsubscribedUserModalComponent, {
		                	title: this.translate.instant('account.unsubscribeFromMailing.title'),
		                	data: { message: this.translate.instant('account.unsubscribeFromMailing.message'),
		                      messageCheckbox: this.translate.instant('account.unsubscribeFromMailing.messageCheckbox'),
		        			  messageContinue: this.translate.instant('account.unsubscribeFromMailing.messageContinue')
		                	}
		         		}).subscribe((result) => {
	                        if(result){
	                        	this.loginService.agreeTermsOfUserByEmail(login).subscribe((res) => {
	                        		// console.log('Agree Terms Of User By Email success: ' + login.email);
	                        		this.loginService.userLogin(login)
		                                .subscribe((res) => {
		                                    this.loginUserRequest(login);
		                                }, (error) => {
		                                    this.error = this.apiService.getMessageFromError(error,
	                                            this.translate.instant('account.login.failAgree'));
		                                })
	                        	}, (error) => {
	                        		throw error;
	                        	})
	                        }
	                    });
	                    this.close();
	                }
            	}
                
            });
    }

    openCreateAccountModal() {
    	this.ga.emitEvent('Sign In Form', 'Create a free account', 'Click');
        this.result = 'SIGN UP';
        this.close();
    }
    
    closeLogIn() {
        this.result = 'CLOSE LOG IN';
        this.close();
    }

    forgotPassword(email) {
        this.ga.emitEvent('Sign In Form', 'Forgot Password', 'Click');
        if (email) {
            this.loginService.resetPasswordMail(email)
                .subscribe((res) => {
                	window.location.href='/#/home';
                    this.modalService.open(GenericModalComponent, {
                        title: this.translate.instant('common.success'),
                        data: {
                       		order : 0,
		                	addFooterBtn : true,
		                	isCancel: true,
		                	cancelText: this.translate.instant('common.close'),
		                    centered: true,
                            message: this.translate.instant('account.login.emailMessag')
                        }
                    }).subscribe((modal) => {
                    });
                }, (err) => {
                	if(err.status == 0) {
                		window.location.href='/#/error-page';
                		this.close();
                	} else {
                		this.error = this.apiService.getMessageFromError(err, this.translate.instant('account.login.failedReset'));
                	}
                });
        } else {
            this.translate.get('account.emailRequired').subscribe((res: string) => {
                this.error = res;
            });
            
        }
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/account/login/login.component.ts